import { useState, useEffect } from 'react';
import { EmojiVariant } from '@quicktools/emojis';
import UAParser from 'ua-parser-js';

const parser = new UAParser();
const results = parser.getResult();
const { name } = results.os;

const useDefaultDeviceType = () => {
  const [deviceType, setDeviceType] = useState<EmojiVariant>('default');

  useEffect(() => {
    if (name === 'Mac OS' || name === 'iOS') {
      return setDeviceType('apple');
    }

    if (/windows/i.test(name)) {
      return setDeviceType('microsoft');
    }

    if (/android/i.test(name)) {
      setDeviceType('samsung');
    }

    if (/chromium/i.test(name)) {
      setDeviceType('google');
    }
  }, []);

  return deviceType;
};

export default useDefaultDeviceType;
